<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="是否显示：" prop="businessStatus">
            <el-radio-group v-model="ruleForm.businessStatus">
              <el-radio :label="1">开启</el-radio>
              <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="资质内容：" prop="businessContent">
            <editor :value="ruleForm.businessContent" :height="350" v-model="ruleForm.businessContent"></editor>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { saveOrUpdateShopConfig, fetchShopConfigDetail } from '@/api/shop'
export default {
  name: 'ShopBusinessQualification',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      fullscreenLoading: false,
      ruleForm: {
        businessStatus: '',
        businessContent:''
      }
    }
  },
  mounted () {
    let that = this
    fetchShopConfigDetail({}).then((res) => {
      if (res.errorCode === '0000') {
        let data = res.data
        that.ruleForm.businessStatus = data.businessStatus
        that.ruleForm.businessContent = data.businessContent
      }
    })
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 保存操作
    saveBtn () {
      let that = this
      let businessStatus = that.ruleForm.businessStatus
      let businessContent = that.ruleForm.businessContent
      if (businessStatus === '') {
        this.$message.error('请选择是否显示')
        return false
      }
      let passData = {
        businessStatus: businessStatus,
        businessContent:businessContent
      }
      saveOrUpdateShopConfig(passData).then((res) => {
       that.backDataFun(res)
      })
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(0)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/shop/BusinessQualification.vue